import areEquivalentUserPromptEvents from '@/lib/activityEvents/areEquivalentUserPromptEvents.js';
import isPendingUserBubbleEvent from '@/lib/activityEvents/isPendingUserBubbleEvent.js';

const findPendingUserReplacementIndex = ({ existingEvents, incomingEvent }) => {
  if (incomingEvent?.type !== 'bubble') {
    return -1;
  }

  if (
    String(incomingEvent?.className || '')
      .trim()
      .toLowerCase() !== 'user'
  ) {
    return -1;
  }

  if (isPendingUserBubbleEvent(incomingEvent)) {
    return -1;
  }

  return (existingEvents || []).findIndex((existingEvent) => {
    if (!isPendingUserBubbleEvent(existingEvent)) {
      return false;
    }

    return areEquivalentUserPromptEvents({
      existingEvent,
      incomingEvent
    });
  });
};

export default findPendingUserReplacementIndex;
